import React from "react";
import styles from "../../../assets/css/modules/shared/groups/number-step-list.css";

export default function(props) {
  let items = props.children
    ? props.children.map
      ? props.children
      : [props.children]
    : [];

  return items.map((child, index) => (
    <div className={styles.stepContainer} key={index} data-count={index + 1}>
      {child}
    </div>
  ));
}
